module.exports = __webpack_public_path__ + "assets/img/101401.99c1deb7.png";